import Vue from 'vue';
import Router from 'vue-router';
import Title from "../util/vue-wechat-title";

import configRoutes from "./flash-config";
import expressRoutes from "./express";
import agreementRoutes from "./agreement";
import adRoutes from "./ad";
import apartmentRoutes from "./apartment";
import equipmentPairRoutes from "./equipment-pair";
import downloadRoutes from "./download";
import networkCard from "./network-card";
import storageRoutes from "./storage";
import medical from "./medical";
import traffic from "./traffic";
import fap from "./fap";
import shanyiApp from "./shanyiApp";
import privacy from "./privacy";
import h5Routes from './H5Promotion'

import dashboard from "@/views/dashboard";

Vue.use(Router).use(Title);

export default new Router({
  mode: 'history',
  routes: [{
    name: "dashboard",
    path: "/",
    meta: {
      title: "模块列表"
    },
    component: dashboard
  }].concat(configRoutes, expressRoutes, agreementRoutes, adRoutes, apartmentRoutes, equipmentPairRoutes,
    downloadRoutes, networkCard, storageRoutes, medical, traffic, fap, shanyiApp, privacy,h5Routes),
})
